<div class="container">
  <div *ngIf="!loading">
    <dashboard-info *ngIf="tokenService.getUser().name !== 'sysadmin'">
    </dashboard-info>

    <viggo-core-workspace
      [showDashboard]="false"
      [showTimeline]="false"
      [showCardPerfil]="false"
      [dashboardData]="[]"
      [infoFirstContact]="infoFirstContact"
      [firstContact]="dadosEmpresa ? !dadosEmpresa.id : false"
      [dadosEmpresa]="dadosEmpresa"
      [links]="links"
    ></viggo-core-workspace>
  </div>
  <div class="app-loading" *ngIf="loading">
    <h4 class="text-splash">
      Carregando dados da empresa, por-favor aguarde!
    </h4>
    <div class="content-spinner">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </svg>
    </div>
  </div>
</div>
